import React, { useState } from 'react'

// Interfaces
import { ComplementaryAnswer, ComplementaryField } from '../../interfaces/Question'

// i18n
import { useTranslation } from '../../translations/useTranslation'
import { InputText } from '../InputText'


type FieldCopyRecord = Record<string, string>

interface FieldProps {
    name: string
    label: string
    value: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

interface ComplementaryFieldsProps {
    fields: ComplementaryField[],
    answersFields: ComplementaryAnswer | undefined
    onChange: (answers: FieldCopyRecord) => void
}

const Field: React.FC<FieldProps> = ({ name, label, value, onChange }) => (
    <div className="membership-app__complementary-field">
        <InputText placeholder={label} name={name} value={value} onChange={onChange} />
    </div>
)

export const ComplementaryFields: React.FC<ComplementaryFieldsProps> = ({ fields, answersFields, onChange }) => {

    const { t } = useTranslation()

    const [answers, setAnswers] = useState<FieldCopyRecord>(() => {
        if (!answersFields) {
            return fields.reduce((accum, field) => ({
                ...accum,
                [field.name]: ''
            }), {})
        } else {
            return answersFields;
        }
    })

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setAnswers({...answers, [name]: value })
        onChange({ ...answers, [name]: value })
    }

    return (
        <div className="membership-app__complementary-fields">
            {Object.entries(fields).map(([_, value]) => (
                <Field 
                    key={value.name}
                    name={value.name} 
                    value={answers[value.name]} 
                    label={t(value.label)}
                    onChange={handleOnChange} />
            ))}
        </div>
        
    )
}